import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-infoband',
    templateUrl: './infoband.component.html',
    styleUrls: ['./infoband.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InfobandComponent {

  @Input() items: any = [];

}
